// extracted by mini-css-extract-plugin
module.exports = {"container":"fixedOverlay__container___2IWCf"};